import React from 'react';
import { Box, Button } from '@mui/material';
import RibbonMenuExpandMoreButton from './RibbonMenuExpandMoreButton';
import styles from './RibbonMenuGroup.module.scss';
import RibbonButtonSize from '../RibbonButtonSize';
import type { IRibbonBtnConfig } from '../RibbonConfig';
import { GlobalVariables } from '../../../../pdf/GlobalVariables';
import { useSelector } from 'react-redux';
import {
    eplassSliceListStamps,
    eplassSliceListUserStamps,
    eplassSliceStampName,
} from '../../../../Redux/EplassSlice';
import { GlobalDialogs } from '../../../../pdf/GlobalDialogs';
import type { IStamp, IUserStamp } from '../../../../types';
import { ApryseSDK } from '../../../../pdf/ApryseSDK';
import { backendApiUrl } from '../../../../App';

export default (props: IRibbonBtnConfig) => {
    const stamps = useSelector(eplassSliceListStamps);
    const userStamps = useSelector(eplassSliceListUserStamps);
    const selectedStamp = useSelector(eplassSliceStampName);

    const stampIcon = React.useMemo(() => {
        let currentStampUri = '';
        let currentStampName = '';

        const standardStamp = stamps?.find(stamp => stamp.name === selectedStamp);

        if (standardStamp) {
            currentStampUri = standardStamp.preview;
            currentStampName = standardStamp.name;
        } else {
            const userStamp = userStamps?.find(stamp => stamp.id === selectedStamp);

            if (userStamp) {
                currentStampUri = backendApiUrl.stamps.image.replace('{id}', userStamp.id) + '/72';
                currentStampName = userStamp.name;
            }
        }

        return (
            <img
                alt={currentStampName || 'stamp'}
                src={currentStampUri}
                style={{
                    maxHeight: '72px',
                    maxWidth: '100px',
                }}
            />
        );
    }, [selectedStamp]);

    return (
        <Box className={styles.buttonGroup}>
            <Button
                id={GlobalVariables.isForTestRun ? 'rbnMenuBtnCreateStamp' : undefined}
                className={styles.stampButton}
                disabled={!props.config.Enabled}
                onClick={() => {
                    ApryseSDK.setToolMode(ApryseSDK.ToolsENUM.CREATE_STAMP);
                    // ToDO: workaround as the first call gets changed internally in Apryse SDK?
                    setTimeout(() => {
                        ApryseSDK.setToolMode(ApryseSDK.ToolsENUM.CREATE_STAMP);
                    }, 50);
                }}
            >
                {stampIcon}
            </Button>
            <RibbonMenuExpandMoreButton
                key={`btnSelStampDropdownMenu-${props.config.Key}`}
                config={{
                    ...props.config,
                    Callback: () => {
                        GlobalDialogs.showStampDialog();
                    },
                }}
                size={RibbonButtonSize.DropDown}
            />
        </Box>
    );
};
